export function getBoundLeafIds(flat, boundIds) {
  const parentIds = new Set(
    (flat || [])
      .map(node => Number(node.parentId))
      .filter(parentId => parentId !== 0),
  );
  return (boundIds || []).filter(id => !parentIds.has(Number(id)));
}

export function mergeCheckedIds(checkedIds, halfCheckedIds) {
  return Array.from(new Set([...(checkedIds || []), ...(halfCheckedIds || [])]));
}
